import { Component, Inject, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatTableModule } from '@angular/material/table';

import { TranslateModule } from "@ngx-translate/core";
import {
  MomentPipe,
  TransformToLangCodePipe,
  TranslateAlarmCategoryPipe,
  TranslateAlarmReasonPipe,
} from "app/pipes/pipes";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment-timezone';

export interface PeriodicElement {
  timeString: string;
  date: string;
  time: string;
  eventName: string;
  user: string;
}

let ELEMENT_DATA: PeriodicElement[] = [
];


@Component({
    selector: 'app-event-history-dialog',
    imports: [
    MatTableModule,
    TranslateModule
],
    templateUrl: './event-history-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['./event-history-dialog.component.css']
})

export class EventHistoryDialogComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<EventHistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
  }
  close(): void {
    ELEMENT_DATA = [];
    this.dialogRef.close();
  }
  displayedColumns: string[] = ['date', 'time', 'event', 'user'];
  dataSource = ELEMENT_DATA;

  detailEvents = [
    { key: 'userConnectedAt', eventName: 'USER_CONNECTED_AT' },
    { key: 'userDisconnectedAt', eventName: 'USER_DISCONNECTED_AT' },
    { key: 'anonymizationDisabledAt', eventName: 'ANONYMIZATION_DISABLED_AT' },
    { key: 'anonymizationEnabledAt', eventName: 'ANONYMIZATION_ENABLED_AT' },
    { key: 'microphoneOrSpeakerEnabledAt', eventName: 'MICROPHONE_ENABLED_AT' },
    { key: 'microphoneOrSpeakerDisabledAt', eventName: 'MICROPHONE_DISABLED_AT' },
    { key: 'furnitureViewedAt', eventName: 'FURNITURE_VIEWED_AT' }
  ];

  ngOnInit(): void {

    const eventTypes = ["emaEvents", "callEvents", "smsEvents", "emailEvents", "additionalPresses"]
    
    for (const eventType of eventTypes) {

      if (this.data.hasOwnProperty('alert') && this.data.alert.hasOwnProperty(eventType)) {
        console.log("Processing event type:", eventType, this.data.alert);
        for (const eventArray of this.data.alert[eventType]) {

          var date;
          var time;
          var timeString;
          let eventName = "";
          switch (eventType) {
            case "emaEvents":
              timeString = eventArray.time;
              eventName = eventArray.eventType;
              break;
            case "callEvents":
              timeString = eventArray.LastCallTime;
              eventName = "LAST_CALL";
              break;
            case "smsEvents":
              timeString = eventArray.DeliveringTime;
              eventName = "SMS";
              break;
            case "emailEvents":
              timeString = eventArray.DeliveringTime;
              eventName = "EMAIL";
              break;
            case "additionalPresses":
              timeString = eventArray;  
              eventName = "ADDITIONAL_PRESS";
              break;
          }

          this.dataSource.push({
            timeString: timeString,
            date: moment(timeString).format('l'),
            time: moment(timeString).format('LTS'),
            eventName: eventName,
            user: eventArray.userName ?? ""
          });
        }
      }
    }

    this.dataSource.sort((a, b) => new Date(a.timeString).valueOf() - new Date(b.timeString).valueOf());

  }

}
